module.exports = {
	"pagination": {
		"ListIdentities": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxItems",
			"result_key": "Identities"
		},
		"ListVerifiedEmailAddresses": {
			"result_key": "VerifiedEmailAddresses"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/email-2010-12-01.paginators.json
// module id = 417
// module chunks = 0